// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import RouteBuilder from '@Services/RouteBuilder';
import { CardContentProps } from '../CardContentType';
import StreamCard from '@Organisms/LiveStreamData/StreamCard/StreamCard';
import { PropRender } from '@Organisms/LiveStreamData/PropRenderer/PropRenderer';
import { ICONS } from '@Constants/iconsApp';
import { useLocalMessage } from '@Helpers/locale';

export const DashboardContent = ({ data, base }: CardContentProps): ReactElement => {
    const local = useLocalMessage();
    const { action, details } = base;
    const { _id: dashboardId, title } = data || {};

    const libTitle = {
        create: local('stream.card.dashboard.create'),
        update: local('stream.card.dashboard.update'),
        delete: local('stream.card.dashboard.delete'),
    };

    const path = RouteBuilder.compute('dashboards.details', { dashboardId });
    const displayTitle = action === 'delete' ? libTitle.delete : title;

    return (
        <StreamCard icon={<ICONS.CommentOutlined />} title={displayTitle} path={path} base={base} parent={parent}>
            {Object.entries(details).map(([key, value]) => (
                <PropRender key={dashboardId + key} prop={key} value={value} />
            ))}
        </StreamCard>
    );
};
